import {
  Avatar,
  ButtonBase,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  getUserInitials,
  useUser,
  UserMenuPopover,
} from "@4uhub/lib4uhub";
import useLogout from "../../../hooks/useLogout";

const UserAvatar = () => {
  const { logout } = useLogout();

  const navigate = useNavigate();

  const { eI } = useParams();

  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openHandler = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closeHandler = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const preferencesHandler = useCallback(() => {
    closeHandler();
    navigate(`/e/${eI}/dashboard/preferences`);
  }, [closeHandler, navigate, eI]);

  const { user } = useUser();

  return (
    <>
      <ButtonBase
        onClick={openHandler}
        sx={(theme) => ({
          width: "100%",
          justifyContent: "flex-start",
          gap: "10px",
          padding: "8px",
          borderRadius: "12px",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        })}
      >
        <Avatar
          alt={user.fullName}
          sx={{ width: 34, height: 34, fontSize: "0.875rem" }}
        >
          {getUserInitials(user.fullName)}
        </Avatar>
        <Stack direction={"column"} alignItems={"flex-start"} overflow={"hidden"}>
          <Typography variant="body2" noWrap>
            {user.fullName}
          </Typography>
          <Typography
            variant="caption"
            color={(theme) => theme.palette.text.secondary}
            noWrap
          >
            {user.email}
          </Typography>
        </Stack>
      </ButtonBase>

      <UserMenuPopover
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closeHandler}
        onPreferences={preferencesHandler}
        onLogout={logout}
        anchorOrigin={{
          vertical: matches ? "bottom" : "top",
          horizontal: matches ? "left" : "right",
        }}
        transformOrigin={{
          vertical: matches ? "top" : "bottom",
          horizontal: "left",
        }}
      />
    </>
  );
};

export default UserAvatar;
